module.exports = __webpack_public_path__ + "img/MW.68f1d0d1.svg";